import { useState, useEffect } from 'react';

export function useCountdown(targetMs) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const diff = Math.max(0, targetMs - now);
  return {
    diff,
    days:  Math.floor(diff / 86400000),
    hrs:   Math.floor((diff % 86400000) / 3600000),
    mins:  Math.floor((diff % 3600000) / 60000),
    secs:  Math.floor((diff % 60000) / 1000),
    ended: diff <= 0,
  };
}
